import { MetaRobots, PageMeta } from '@graphcommerce/next-ui'
import { i18n } from '@lingui/core'

export function InstantSearchMeta({
  storeB2B,
  metaRobots,
}: {
  storeB2B: boolean
  metaRobots: MetaRobots[]
}) {
  return (
    <PageMeta
      title={i18n._(/* i18n */ 'Search')}
      metaRobots={storeB2B ? ['noindex', 'nofollow'] : metaRobots}
      canonical='/search'
    />
  )
}
